import * as React from "react";
import {resourcesHelper} from "@falcon/services";
import {TrustLogoComponent} from "@falcon/plugin-falcon-journey";
import {IApplicationGuard, lazyInject, TypeDefs} from "@athena-portal/core";

const {
    PRIVACY_NOTICE_URL,
    COOKIE_POLICY_URL
} = resourcesHelper;

export default class FalconFooter extends React.Component {
    @lazyInject(TypeDefs.ApplicationGuard)
    private readonly applicationGuard: IApplicationGuard;

    private readonly isBritanniaBrand = () => resourcesHelper.THEME === 'Britannia';
    public render() {
        const complaintsUrl = this.applicationGuard.isAuthenticated() ? "/dashboard/complaints" : "/complaints";
        return (
            <footer className="falcon-footer">
                <div className="falcon-footer-divider"></div>
                <div className="entrust-section">
                    <div id="trust-logo" className="security-logo position-relative">
                        <TrustLogoComponent/>
                    </div>
                    <div className={"entrust-section-wording"}>
                        <div className={"entrust-section-title"}>
                        We'll keep your details safe
                        </div>
                        <div className={"entrust-section-description"}>
                            Our website is constantly monitored to <br/>
                            check for harmful viruses or malware.
                        </div>
                    </div>
                    {!this.isBritanniaBrand() && (<div className={"d-flex justify-content-end flex-grow-1"}>
                        <img src={`/Allianz/img/allianz-olympic-logo.svg`}
                             alt={`${resourcesHelper.THEME} olympics logo icon`}/>
                    </div>)}
                </div>
                <div className={"falcon-footer-divider-bottom"}></div>
                <hr aria-hidden="true"/>
                <div className={"trademark-section"}>
                    <div className={"links-container d-mobile-none"}>
                        <a href={complaintsUrl} id="complaints">Complaints</a>
                        <a href={COOKIE_POLICY_URL} target="_blank" id="cookie-policy">
                            Our cookie policy
                        </a>
                        <a href={PRIVACY_NOTICE_URL} id="data-rights" target="_blank">
                            Personal data rights
                        </a>
                        <br/><br/>
                    </div>

                    <div className={"links-container d-desktop-none"}>
                        <a href={complaintsUrl} id="complaints">Complaints</a>
                        <a href={COOKIE_POLICY_URL} target="_blank" id="cookie-policy">
                            Our cookie policy
                        </a>
                        <a href={PRIVACY_NOTICE_URL} id="data-rights" target="_blank">
                            Personal data rights
                        </a>
                        <br/><br/>
                    </div>
                    <hr aria-hidden="true"/>
                    <div className={"trademark-container"}>
                        <div>
                            {resourcesHelper.TRADEMARK}
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}
